import React, { useEffect } from "react";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
} from "reactstrap";
// Formik validation
import { useFormik } from "formik";

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useHistory } from "react-router-dom";
import ResultHandler from "../../../../components/ResultHandler";
import { addPool } from "../../../../api/pools";
import * as Yup from "yup";
import FormButtonHandler from "../../../../components/FormButtonHandler";
import { useResponse } from "../../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import FIELDS, { MASTER_FIELDS } from "./CONSTANT";
import PoolForm from "./PoolForm";
import { useParams } from "react-router-dom";

const TYPES = {
  select: null,
  "add-more": [],
  checkbox: false,
  file: null,
  date: null,
};

const initialValues = {};
const FIELDS_VALIDATION = {};

function getValidationRules(type) {
  return MASTER_FIELDS.forEach((f) => {
    initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "";
    if (f.type == "file") {
      FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
        "This Field Is Required"
      );
    } else {
      FIELDS_VALIDATION[f.key] = Yup.string().required(
        "This Field Is Required"
      );
    }
  });
}

const AddPool = () => {
  const { t } = useTranslation();
  const {contractId} = useParams()
  let navigate = useHistory();

  const { setData, loading, error, success } = useResponse(addPool, () => {
    navigate.push("/pools");
  });

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {...initialValues, company_contracts: contractId == 'noId' ? "" : +contractId},
    validationSchema: Yup.object(getValidationRules()),
    onSubmit: (data) => {
      data.company_contract_id = contractId == 'noId' ? +data.company_contracts : +contractId
      setData({ data, type: "add" });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title={t("Pools")} breadcrumbItem={"Add Pool"} />

          <Form
            className="needs-validation"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <PoolForm validation={validation} />

            <FormButtonHandler btnTxt="Add" loading={loading} />

            <ResultHandler
              error={error}
              success={success}
              successMsg={"Created Successfully!"}
            />
          </Form>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddPool;
